import React, { useEffect, useState } from 'react';
import {
  Badge,
  Button, Collapse, Divider, Tooltip,
} from 'antd';
import dayjs from 'dayjs';
import { ReloadOutlined } from '@ant-design/icons';
import { EmailsQueueStatus, useEmailsQueueStatusGet } from '../../../../hooks/api/inviteUsers';
import Loading from '../../../Common/Loading';
import { dateTimeFormat } from '../../../../contstant';
import CollapseItem from './CollapseItem';
import { useInviteUsersContext } from '../../../../context/inviteUsersContext';

import styles from './index.module.scss';

function LoadingContainer() {
  return (
    <div style={{ height: '60px', position: 'relative' }}>
      <Loading absolute />
    </div>
  );
}

function EmailsQueue() {
  const emailsQueueStatusGet = useEmailsQueueStatusGet();
  const [data, setData] = useState<EmailsQueueStatus[]>([]);
  const [key, setKey] = useState(crypto.randomUUID());

  /** When user sends invite request reload emails queue */
  const { inviteUsersBulk } = useInviteUsersContext();

  useEffect(() => {
    if (inviteUsersBulk.data && !inviteUsersBulk.error && !inviteUsersBulk.loading) {
      fetchQueueStatus();
    }
  }, [inviteUsersBulk.data, inviteUsersBulk.loading]);

  /** Fetch & set data in state */
  const fetchQueueStatus = () => {
    emailsQueueStatusGet.fetch();
    setKey(crypto.randomUUID());
  };

  useEffect(() => {
    if (emailsQueueStatusGet.data && !emailsQueueStatusGet.error && !emailsQueueStatusGet.loading) {
      setData(emailsQueueStatusGet.data);
    }
  }, [emailsQueueStatusGet.data, emailsQueueStatusGet.loading]);

  if (emailsQueueStatusGet.loading && data.length === 0) {
    return <LoadingContainer />;
  }
  if (!emailsQueueStatusGet.data?.length || !data?.length) {
    return null;
  }

  return (
    <Collapse
      ghost
      bordered={false}
      items={[{
        label: (
          <Divider className={styles.divider}>
            Emails queue
            <Tooltip title="Reload emails queue statuses">
              <Button
                className={styles.reloadButton}
                onClick={(e) => {
                  e.stopPropagation();
                  fetchQueueStatus();
                }}
                disabled={emailsQueueStatusGet.loading}
                size="small"
                type="primary"
              >
                <ReloadOutlined />
              </Button>
            </Tooltip>
          </Divider>
        ),
        classNames: { header: styles.collapseHeader },
        children: (
          <div className={styles.container}>
            {emailsQueueStatusGet.loading && <Loading absolute />}

            <Collapse
              key={key}
              accordion
              className={styles.collapseScroll}
                      // defaultActiveKey={data?.[0]?.group}
              items={data.map((item) => {
                const {
                  group, done, total, type,
                } = item;

                return ({
                  key: group,
                  label: (
                    <div className={styles.collapseLabel}>
                      {[
                        { label: 'Group ID', value: group },
                        { label: 'Total', value: total },
                        {
                          label: 'Done',
                          value: <Badge status={total === done ? 'success' : 'processing'} text={done} />,
                        },
                        { label: 'Type', value: type },
                        { label: 'Creation Time', value: dayjs(Number(group)).format(dateTimeFormat) },
                      ].map(({ label, value }) => (
                        <div key={label} className={styles.subItem}>
                          <span>{label}</span>
                          <span>{value || '-'}</span>
                        </div>
                      ))}
                    </div>
                  ),
                  children: (<CollapseItem rowData={item} />),
                });
              })}
            />
          </div>
        ),
      }]}
    />
  );
}

export default EmailsQueue;
